import { ConditionalLink } from '@navigation';
import { Injectable } from '@angular/core';
import { PlantService } from '@plants';
import { Config } from '@config';

@Injectable()
export class WebAccessConditionalLink implements ConditionalLink {
    constructor(private plantService : PlantService, private config : Config){}

    public async hasLink(linkData){
        const currentPlant = await this.plantService.getCurrentPlant();
        if(
            currentPlant.isMeteringDevice
            && currentPlant.serialNumber.startsWith('EV')
            && this.config.meteringAccessWebUrl
        ){
            return true;
        }
        return false;
    }
}